import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { UserRound } from "lucide-react";

export default function VendeurFilter({ value, onChange, testid = "vendeur-filter-select" }) {
  const { can } = useAuth();
  const [vendeurs, setVendeurs] = useState([]);
  const visible = can("historique_tous") || can("rapports");

  useEffect(() => {
    if (visible) api.get("/vendeurs").then((r) => setVendeurs(r.data)).catch(() => {});
  }, [visible]);

  if (!visible) return null;
  return (
    <div className="flex items-center gap-2">
      <UserRound className="w-4 h-4 text-muted-foreground" />
      <Select value={value || "tous"} onValueChange={(v) => onChange(v === "tous" ? "" : v)}>
        <SelectTrigger data-testid={testid} className="w-52 bg-background border-border text-foreground"><SelectValue placeholder="Caissier" /></SelectTrigger>
        <SelectContent className="bg-card border-border text-foreground">
          <SelectItem value="tous">Tous les caissiers</SelectItem>
          {vendeurs.map((v) => <SelectItem key={v.id} value={v.id} data-testid={`vendeur-option-${v.id}`}>{v.nom}</SelectItem>)}
        </SelectContent>
      </Select>
    </div>
  );
}
